import { stateTypeF } from "../../state";

export const resetDashboard = (state: stateTypeF) => {
	state.setInputPage(0);
	state.resetModelStates(state.saveState.modelTraining.modelStates);
	state.resetModelProgress();
	state.resetSavedModels();
	state.resetErrorStates(state.saveState.dataset.columns);
	state.resetTotalTrainProgress();
	state.saveState.personaPrediction.personas = [];
	state.saveState.batchPrediction.batchData = undefined;
	state.saveState.batchPrediction.batchHistData = undefined;
	state.setBatchFilteredData(undefined);
	state.setBatchFilteredData(undefined);
	state.setCurrentPersonaPage(1);
	state.saveState.savedModels = [];
	state.setSaveState(state.saveState);
};
